export default "__VITE_ASSET__CP$UWhxD__"